<style>
</style>
<template>
    <v-container lighten-5>
        <v-row>
            <v-col cols="12" sm="12" md="12">
                <span class="mx-2 secondary--text display-2 float-left">Personas</span>
            </v-col>
            <v-col cols="12" sm="12" md="12">
                <v-btn class="mx-2 float-right" fab small dark color="accent" @click="verFiltros=!verFiltros">
                    <v-icon dark>filter_list</v-icon>
                </v-btn>
            </v-col>
            <v-col cols="12" sm="12" md="12" v-if="tabla">
                <v-card elevation="0" class="rounded-xl">
                    <v-data-iterator :items="lista" :page.sync="page" :loading="loadingTable" :item-key="tabla.itemKey" :items-per-page="10" single-expand hide-default-footer :sort-by="tabla.orderBy" :sort-desc="tabla.desc">
                        <template v-slot:header>
                            <Dfiltros v-if="verFiltros" :onBuscar="search" v-bind:filtros="filtros" />
                            <v-toolbar dark class="mb-1">
                                <v-btn class="mx-2 primary--text" tile color="white" :to="{ name: 'Personascreate' }">
                                    agregar
                                </v-btn>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <div class="flex-grow-1"></div>
                                <v-btn class="mx-2 primary--text" v-if="user.role.indexOf('ADMIN') > -1" tile color="white" :loading="LoadingMigracion" @click="migrar('funcionarios')">
                                    migrar funcionarios
                                </v-btn>
                                <v-btn class="mx-2 primary--text" v-if="user.role.indexOf('ADMIN') > -1" tile color="white" :loading="LoadingMigracion" @click="migrar('estudiantes')">
                                    migrar estudiantes
                                </v-btn>
                                <v-btn class="mx-2 primary--text" v-if="user.role.indexOf('ADMIN') > -1" tile color="white"  @click="dialogMasivo = true">
                                    importar egresados
                                </v-btn>
                                 <v-btn class="mx-2 primary--text" v-if="user.role.indexOf('ADMIN') > -1" tile color="white" :loading="LoadingExp" @click="exportarTabla()">
                                    exportar
                                </v-btn>
                            </v-toolbar>
                        </template>
                        <template v-slot:default="{ items, isExpanded, expand }">
                            <v-container class="pt-0">
                                <v-row align="center" justify="center" :class="($vuetify.theme.dark)?'grey darken-4':'grey lighten-3'">
                                    <v-col v-for="item in items" :key="item.comaId" cols="12" sm="12" md="10" lg="10">
                                        <v-card elevation="0" class="rounded-xl">
                                            <v-card-title :class="`${($vuetify.breakpoint.mdAndUp)?'subtitle-1':'subtitle-2'}  font-weight-bold`">
                                                <v-row no-gutters>
                                                    <v-col cols="10" sm="10" md="10" lg="10">
                                                        <v-row no-gutters>
                                                            <template v-for="(p,i) in tabla.primarios">
                                                                <v-col :cols="p.tamaño.cols" :sm="p.tamaño.sm" :md="p.tamaño.md" :lg="p.tamaño.lg" :key="i">
                                                                    {{p.titulo}} <span :class="p.class">
                                                                        {{ p.valor(item) }}
                                                                    </span>
                                                                </v-col>
                                                            </template>
                                                        </v-row>
                                                    </v-col>
                                                    <v-col cols="2" sm="2" md="2" lg="2">
                                                        <v-menu bottom left>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon outlined v-bind="attrs" v-on="on">
                                                                    <v-icon class="material-icons-two-tone">more_vert</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <v-list>
                                                                <template v-for="(m, i) in tabla.menu">
                                                                    <template v-if="m.show(item)">
                                                                        <v-list-item v-if="m.tipeAction=='link'" :key="i" :to="m.action(item)">
                                                                            <v-list-item-icon>
                                                                                <v-icon :color="m.color">{{m.icon}}</v-icon>
                                                                            </v-list-item-icon>
                                                                            <v-list-item-title>{{ m.title }}</v-list-item-title>
                                                                        </v-list-item>
                                                                        <v-list-item v-else :key="i" @click="m.action(item)">
                                                                            <v-list-item-icon>
                                                                                <v-icon :color="m.color">{{m.icon}}</v-icon>
                                                                            </v-list-item-icon>
                                                                            <v-list-item-title>{{ m.title }}</v-list-item-title>
                                                                        </v-list-item>
                                                                    </template>
                                                                </template>
                                                            </v-list>
                                                        </v-menu>
                                                    </v-col>
                                                </v-row>
                                            </v-card-title>
                                            <v-divider></v-divider>
                                            <v-card-text>
                                                <v-row no-gutters>
                                                    <template v-for="(p,i) in tabla.segundarios">
                                                        <v-col :cols="p.tamaño.cols" :sm="p.tamaño.sm" :md="p.tamaño.md" :lg="p.tamaño.lg" :key="i">
                                                            {{p.titulo}} <span :class="p.class">
                                                                {{ p.valor(item) }}
                                                            </span>
                                                        </v-col>
                                                    </template>
                                                    <v-col cols="12" sm="12" md="12" lg="12" v-if="tabla.expandible">
                                                        <v-row>
                                                            <v-col cols="2" sm="2" md="1" lg="1">
                                                                <v-btn color="grey" icon outlined @click="() => expand(item, !isExpanded(item))">
                                                                    <v-icon v-if="!isExpanded(item)">mdi-chevron-down</v-icon>
                                                                    <v-icon v-else>mdi-chevron-up</v-icon>
                                                                </v-btn>
                                                            </v-col>
                                                            <v-col cols="10" sm="10" md="11" lg="11">
                                                                <span class="headline primary--text">{{tabla.expandibleTitle(item)}}</span>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                            <template v-if="tabla.expandible">
                                                <v-divider v-if="isExpanded(item)"></v-divider>
                                                <v-card-text v-if="isExpanded(item)">
                                                    <v-container>
                                                        <template v-for="items in tabla.expandibleItems(item) ">
                                                            <v-sheet min-height="100%" width="100%" :key="items[tabla.expandibleKey]">
                                                                <v-row no-gutters :class="`${($vuetify.theme.dark)?'grey darken-4':'grey lighten-3'} mb-5 py-2 px-2`">
                                                                    <template v-for="(p,i) in tabla.expanItem">
                                                                        <v-col :cols="p.tamaño.cols" :sm="p.tamaño.sm" :md="p.tamaño.md" :lg="p.tamaño.lg" :key="i">
                                                                            {{p.titulo}} <span :class="p.class">
                                                                                {{ p.valor(items) }}
                                                                            </span>
                                                                        </v-col>
                                                                    </template>
                                                                    <v-col cols="2" sm="2" md="2" lg="2" v-if="tabla.expanMenu.length > 0">
                                                                        <v-menu bottom left>
                                                                            <template v-slot:activator="{ on, attrs }">
                                                                                <v-btn icon outlined v-bind="attrs" v-on="on">
                                                                                    <v-icon class="material-icons-two-tone">more_vert</v-icon>
                                                                                </v-btn>
                                                                            </template>
                                                                            <v-list>
                                                                                <template v-for="(m, i) in tabla.expanMenu">
                                                                                    <template v-if="m.show(items)">
                                                                                        <v-list-item v-if="m.tipeAction=='link'" :key="i" :to="m.action(items)">
                                                                                            <v-list-item-icon>
                                                                                                <v-icon :color="m.color">{{m.icon}}</v-icon>
                                                                                            </v-list-item-icon>
                                                                                            <v-list-item-title>{{ m.title }}</v-list-item-title>
                                                                                        </v-list-item>
                                                                                        <v-list-item v-else :key="i" @click="m.action(items)">
                                                                                            <v-list-item-icon>
                                                                                                <v-icon :color="m.color">{{m.icon}}</v-icon>
                                                                                            </v-list-item-icon>
                                                                                            <v-list-item-title>{{ m.title }}</v-list-item-title>
                                                                                        </v-list-item>
                                                                                    </template>
                                                                                </template>
                                                                            </v-list>
                                                                        </v-menu>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-sheet>
                                                        </template>
                                                    </v-container>
                                                </v-card-text>
                                            </template>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </template>
                        <template v-slot:no-data>
                            <v-row class="mt-2" align="center" justify="center">
                                <v-col cols="10" sm="10" md="10" lg="10">
                                    <v-alert text dense color="primary" icon="mdi-database-search" border="left">
                                        No se encontro nada.
                                    </v-alert>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:loading>
                            <v-row class="mt-2" align="center" justify="center">
                                <v-col cols="12" sm="12" md="12" lg="12">
                                    <Loader />
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:footer>
                            <Paginacion v-on:cambiarPagina="page = $event" :onSearch="search" v-bind:propiedades="{filtros,page,pageCount,Count}" />
                        </template>
                    </v-data-iterator>
                </v-card>
            </v-col>
        </v-row>
          <v-dialog v-model="LoadingMigracion" persistent width="800px" max-width="800px">
                <v-card>
                    <v-card-title>
                        <span class="headline">Actualizacion de {{ tipo }}</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="12" class="text-center">
                                    <span class="headline">MIGRANDO DATOS, por favor no salir de esta ventana....</span>
                                </v-col>
                                <v-col cols="12" sm="12" md="12" class="text-center">
                                    <v-progress-linear v-model="porcentaje" color="primary" height="25">
                                        <template v-slot:default="{ value }">
                                            <strong>{{ Math.ceil(value) }}% de {{total}} {{ tipo }}..</strong>
                                        </template>
                                    </v-progress-linear>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogMasivo" persistent width="800px" max-width="800px">
                <v-card>
                    <v-card-title>
                        <span class="headline">Cargue de egresados</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-container>
                            <v-row v-if="loadingForm" align="center" justify="center">
                                <v-col cols="12" sm="12" md="12" lg="12">
                                    <Loader />
                                </v-col>
                            </v-row>
                            <v-row v-else-if="!loadingGuardar">
                                <v-col cols="12" sm="12" md="8">
                                    <v-file-input outlined v-model="file" show-size label="Archivo" @change="onFileChange"></v-file-input>
                                </v-col>
                            </v-row>
                            <v-row v-else>
                                <v-col cols="12" sm="12" md="12" class="text-center">
                                    <span class="headline">CARGANDO EGRESADOS....</span>
                                </v-col>
                                <v-col cols="12" sm="12" md="12" class="text-center">
                                    <v-progress-linear v-model="porcentaje" color="primary" height="25">
                                        <template v-slot:default="{ value }">
                                            <strong>{{ Math.ceil(value) }}% de {{total}} egresados..</strong>
                                        </template>
                                    </v-progress-linear>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn color="primary darken-1" text v-if="!loadingGuardar" @click="dialogMasivo = false">Cancelar</v-btn>
                        <v-btn color="primary darken-1" dark v-if="!loadingGuardar" @click="importar">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogFoto" width="600px" max-width="800px">
                <v-card>
                    <v-card-title>
                        <span class="headline">Aprobar foto</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                  <v-col cols="12" sm="12" md="12" class="text-center">
                                    <v-img class="text-center" v-if="foto" :src="foto" aspect-ratio="1" contain max-width="550" max-height="550"></v-img>
                                  </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn color="primary darken-1" text v-if="!loadingGuardar" @click="dialogFoto = false">Cancelar</v-btn>
                        <v-btn color="primary darken-1" dark v-if="!loadingGuardar" @click="aprovarFoto(1)">Aprobar</v-btn>
                        <v-btn color="primary darken-1" dark v-if="!loadingGuardar" @click="aprovarFoto(2)">Rechazar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
    </v-container>
</template>

<script>
import generales from '../../../mixins/generales.js';
export default {
  mixins: [generales],
  data() {
    return {
      tipo:"",
      foto:null,
     dialogFoto:false,
     copeId:null,
      tabla: {
        itemKey: 'copeId',
        orderBy: 'createdAt',
        expandible: false,
        expandibleKey: 'copeId',
        desc:true,
        primarios: [{
            titulo: 'NOMBRE',
            tamaño: {
              cols: '12',
              sm: '12',
              md: '12',
              lg: '12'
            },
            class: 'primary--text',
            valor: (item) => {
              return `${item.copeNombre}`
            },
            show: (item) => {
              return item ? true : false
            }
          }, {
            titulo: 'IDENTIFICACION',
            tamaño: {
              cols: '12',
              sm: '12',
              md: '12',
              lg: '12'
            },
            class: 'primary--text',
            valor: (item) => {
              return `${item.tipoidentificacion.comaNombrecorto} ${item.copeIdentificacion}`
            },
            show: (item) => {
              return item ? true : false
            }
          },
          {
            titulo: 'TELEFONO',
            tamaño: {
              cols: '12',
              sm: '12',
              md: '12',
              lg: '12'
            },
            class: 'primary--text',
            valor: (item) => {
              return item.copeTelefono
            },
            show: (item) => {
              return item ? true : false
            }
          },

        ],
        segundarios: [
          {
            titulo: 'FECHA',
            tamaño: {
              cols: '12',
              sm: '12',
              md: '12',
              lg: '12'
            },
            class: 'primary--text',
            valor: (item) => {
              return ` ${new Date(item.createdAt).yyyymmdd()} ${ new Date(item.createdAt).hhmm()}`
            },
            show: (item) => {
              return item ? true : false
            }
          },
          {
            titulo: 'EMAIL',
            tamaño: {
              cols: '12',
              sm: '12',
              md: '12',
              lg: '12'
            },
            class: 'primary--text',
            valor: (item) => {
              return item.copeEmail
            },
            show: (item) => {
              return item ? true : false
            }
          },
          {
            titulo: 'DIGITADOR',
            tamaño: {
              cols: '12',
              sm: '12',
              md: '12',
              lg: '12'
            },
            class: 'primary--text',
            valor: (item) => {
              return item.registrador ? item.registrador.username : ''
            },
            show: (item) => {
              return item ? true : false
            }
          },
          {
            titulo: 'EGRESADO',
            tamaño: {
              cols: '12',
              sm: '12',
              md: '3',
              lg: '3'
            },
            class: 'primary--text',
            valor: (item) => {
              return item.esEgresado ? 'SI' : 'NO'
            },
            show: (item) => {
              return item ? true : false
            }
          },
          {
            titulo: 'EMPLEADO',
            tamaño: {
              cols: '12',
              sm: '12',
              md: '3',
              lg: '3'
            },
            class: 'primary--text',
            valor: (item) => {
              return item.esEmpleado ? 'SI' : 'NO'
            },
            show: (item) => {
              return item ? true : false
            }
          },
          {
            titulo: 'ESTUDIANTE',
            tamaño: {
              cols: '12',
              sm: '12',
              md: '3',
              lg: '3'
            },
            class: 'primary--text',
            valor: (item) => {
              return item.esEstudiante ? 'SI' : 'NO'
            },
            show: (item) => {
              return item ? true : false
            }
          },
          {
            titulo: 'ESTADO DE LA FOTO',
            tamaño: {
              cols: '12',
              sm: '12',
              md: '3',
              lg: '3'
            },
            class: 'primary--text',
            valor: (item) => {
              return item.copeFoto && item.copeAprovedFoto==3 ? 'SIN VERIFICAR': ['SIN VERIFICAR','APROBADO','RECHAZADO','SIN SOLICITAR'][item.copeAprovedFoto]
            },
            show: (item) => {
              return item ? true : false
            }
          },
        ],
        expanItem: [],
        expanMenu: [],
        menu: [
          {
            title: 'Aprobar foto',
            icon: 'mdi-badge-account',
            color: 'success',
            tipeAction: 'funcion',
            action: (item) => {
              return this.loadAprovarFoto(item);
            },
            show: (item) => {
              return item ? this.getPermiso('editarPersonas') && item.copeFoto && item.copeAprovedFoto !=1 : false
            }
          },
          {
            title: 'Editar',
            icon: 'create',
            color: 'info',
            tipeAction: 'link',
            action: (item) => {
              return `/sistema/personas/update/${item.copeId}`
            },
            show: (item) => {
              return item ? this.getPermiso('editarPersonas') : false
            }
          },
          {
            title: 'Eliminar',
            icon: 'delete',
            color: 'error',
            tipeAction: 'funcion',
            action: (item) => {
              this.eliminar(item.copeId)
            },
            show: (item) => {
              return item ? this.getPermiso('eliminarPersonas') : false
            }
          },
        ]
      },
      filtros: [{
          campo: "nombre",
          text: "Nombre",
          value: null,
          tipo: "text",
          search: true,
          isLoading: false,
        },
        {
          campo: "identificacion",
          text: "Identificacion",
          value: null,
          tipo: "text",
          search: true,
          isLoading: false,
          /*si es tipo lista descomentar esta parte*/
          /* lista: [],
                    listatext: "nombre del campo que se mostrara",
                    listavalue: "nombre del valor que se mandara"*/
        },
        {
          campo: "registrador",
          text: "Digitador",
          value: null,
          tipo: "text",
          search: true,
          isLoading: false,
        },
        {
          campo: "estadoFoto",
          text: "Estado foto",
          value: null,
          tipo: "lista",
          search: true,
          isLoading: false,
          lista: [{
              eId: 1,
              etext: "APROBADO"
            },
            {
              eId: 0,
              etext: "SIN VERIFICAR"
            },
            {
              eId: 2,
              etext: "RECHAZADO"
            },
            {
              eId: 4,
              etext: "SIN SOLICITAR"
            }
          ],
          listatext: "etext",
          listavalue: "eId"
        },
      ],
      tipoidentificacion: [],
      LoadingMigracion:false,
      porcentaje: 0,
      total: 0,
      interval: {}
    };
  },
  created: async function() {
    this.tipoidentificacion = await this.$apiService.index("sistema/maestra/index/TBL_TIPOIDENT").then(data => data);
    await this.search(this.filtros);
  },
   sockets: {
    sendporcentaje: function(data) {
      this.total = data.cobdTotal;
      this.porcentaje = data.cobdTotal > 0 ? ((data.cobdPorcentaje / data.cobdTotal) * 100) : 0;
    },
  },
  methods: {
    onFileChange(file) {
      this.file = file;
    },
    async migrar(tipo){
      this.tipo = tipo;
       this.LoadingMigracion = true;
      try {
         let estudiantes = await this.$apiService.index(`sistema/personas/${tipo}/`+ this.user.username).then(data => data);
          if (estudiantes) {
            this.$swal.fire({
              title: "Completado!",
              text: "Registro exitoso",
              icon: "success",
              confirmButtonText: "Ok"
            });
          }
        } catch (error) {
          console.log(error)
          this.$swal.fire({
            title: "Algo sucedio!",
            text: "contacta con el administrador",
            icon: "error"
          });
      }
      this.LoadingMigracion = false;
    },
    async search(filtros) {
      this.lista = this.listaCopia = [];
      if(this.user.role.indexOf('ADMIN') < 0){
        filtros.find( e => e.campo == 'registrador').value = this.user.username;
      }
      this.loadingTable = true;
      const data = await this.$apiService.index(`sistema/personas/buscar?${this.filtrar(filtros,this.page)}`).then(data => data);
      if (data) {
        this.lista = this.listaCopia = data.rows;
        this.Count = data.count;
        this.pageCount = Math.ceil((data.count) / 10);
      }
      this.loadingTable = false;
    },
    async importar() {
      try {
        this.errores = [];
        this.loadingGuardar = true;
          if (this.file != null) {
            let formData = new FormData();
            formData.append('file', this.file);
            this.loader = true;
            var guardo = await this.$apiService.createFile("sistema/personas/importar/" + this.user.username, formData).then(data => data);
            if (guardo) {
              this.loader = false;
              this.file = null;
              this.$swal.fire({
                title: "Completado!",
                text: "Registro exitoso",
                icon: "success",
                confirmButtonText: "Ok"
              });
            }
          } else {
            this.$swal.fire({
              title: "Completado!",
              text: "Registro exitoso",
              icon: "success",
              confirmButtonText: "Ok"
            });
          }
          this.dialogMasivo = false;
          await this.search(this.filtros);
      } catch (error) {
        if (error.response && 422 == error.response.status) {
          this.errores = error.response.data.errors;
        } else {
          if (error.response && 403 == error.response.status) {
            this.$router.push('/403');
          } else {
            if (error.response && error.response.data.errores) {
              this.$swal.fire({
                title: "Error en el excel datos invalidos",
                text: error.response.data.errores,
                icon: "error"
              });
            } else {
              console.log(error)
              this.$swal.fire({
                title: "Algo sucedio!",
                text: "contacta con el administrador",
                icon: "error"
              });
            }

          }

        }
      }
      this.loadingGuardar = false;
    },
    async eliminar(id) {
      try {
        let result = await this.$swal.fire({
          title: "Estas seguro?",
          text: "No podras revertir esto!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si, eliminar!"
        }).then(result => result.value);
        if (result) {
          var data = await this.$apiService.delete(`sistema/personas/delete/${id}`).then(data => data);
          if (data) {
            await this.search(this.filtros);
            this.$swal.fire(
              "Eliminado!",
              "ha sido eliminado con exito.",
              "success"
            );
          }
        }
      } catch (error) {
        this.$swal.fire({
          title: "Algo sucedio!",
          text: "contacta con el administrador",
          icon: "error"
        });
      }

    },
    async exportarTabla() {
      this.LoadingExp = true;
      try {
        let personas = await this.$apiService.index(`sistema/personas/exportar?${this.filtrar(this.filtros,1)}`).then(data => data);
        if (personas.length > 0) {
          import('@/vendor/Export2Excel').then(excel => {
            let head = ['NOMBRE','IDENTIFICACION','TELEFONO','EMAIL','DIGITADOR','EGRESADO','EMPLEADO','ESTUDIANTE'];
            let data = personas.map(item => {
              return [
                item.copeNombre,
                item.copeIdentificacion,
                item.copeTelefono,
                item.copeEmail,
                item.registrador ? item.registrador.username : '',
                item.esEgresado ? 'SI' : 'NO',
                item.esEmpleado ? 'SI' : 'NO',
                item.esEstudiante ? 'SI' : 'NO'
              ]
            })
            excel.export_json_to_excel({
              header: head, //Header Required
              data, //Specific data Required
              filename: 'personas-export', //Optional
              autoWidth: true, //Optional
              bookType: 'xlsx' //Optional
            })
          });
        }

      } catch (error) {
        this.$swal.fire({
          title: "Algo sucedio!",
          text: "contacta con el administrador",
          icon: "error"
        });
      }
      this.LoadingExp = false;
    },
    async loadAprovarFoto(item){
      let foto = await this.$apiService.index(`sistema/personas/getImagen?identificacion=${item.copeIdentificacion}`).then((data) => data);
      this.foto = 'data:image/png;base64,' + foto;
      this.copeId = item.copeId;
      this.dialogFoto = true;
    },
    async aprovarFoto(estado) {
      try {
        this.errores = [];
        this.loadingGuardar = true;
            var guardo = await this.$apiService.update("sistema/personas/updateEmail/"+this.copeId, {copeAprovedFoto:estado,copeFechaFoto:new Date().yyyymmdd()}).then(data => data);
            if (guardo) {
              this.$swal.fire({
                title: "Completado!",
                text: "Registro exitoso",
                icon: "success",
                confirmButtonText: "Ok"
              });
            }
          await this.search(this.filtros);
      } catch (error) {
        if (error.response && 422 == error.response.status) {
          this.errores = error.response.data.errors;
        } else {
          if (error.response && 403 == error.response.status) {
            this.$router.push('/403');
          } else {
            if (error.response && error.response.data.errores) {
              this.$swal.fire({
                title: "Error en el excel datos invalidos",
                text: error.response.data.errores,
                icon: "error"
              });
            } else {
              console.log(error)
              this.$swal.fire({
                title: "Algo sucedio!",
                text: "contacta con el administrador",
                icon: "error"
              });
            }
          }
        }
      }
      this.loadingGuardar = false;
      this.dialogFoto = false;
    },

  }
};

</script>
